import './appLoading.css';

export default function AppLoading() {
  return (
    <div className="app-loading" role="status" aria-live="polite" aria-label="Loading TerraEdge">
      <img src="/logo.svg" width="48" height="48" alt="" />
      <div className="app-loading-brand">TERRAEDGE</div>
      <div className="app-loading-caption">INTELLIGENCE PLATFORM</div>
      <span className="app-loading-spinner" aria-hidden="true" />
      <div className="app-loading-message">Loading your dashboard…</div>
    </div>
  );
}
